import React, { FC, memo } from 'react';
import { DropdownWithChildrenProps, DropdownTogglerTypeEnum, TextWrapOption } from '../shared/types';
import { useDropdownWithChildrenContext } from '../shared/context';
import DropdownWithChildrenTogglerButton from '../DropdownWithChildrenTogglerButton';
import DropdownWithChildrenTogglerInput from '../DropdownWithChildrenTogglerInput';

interface Props {
  withSelectionsResult: DropdownWithChildrenProps['withSelectionsResult'];
  isDisabled: DropdownWithChildrenProps['isDisabled'];
  isChildrensContentFilled: DropdownWithChildrenProps['isChildrensContentFilled'];
  isClearable: DropdownWithChildrenProps['isClearable'];
  id: DropdownWithChildrenProps['id'];
  placeholder: DropdownWithChildrenProps['placeholder'];
  dropdownTogglerType: DropdownWithChildrenProps['dropdownTogglerType'];
  selectionsResultType: DropdownWithChildrenProps['selectionsResultType'];
  toggleLabel: DropdownWithChildrenProps['toggleLabel'];
  onOptionsFetch: DropdownWithChildrenProps['onOptionsFetch'];
  dataTestId: DropdownWithChildrenProps['dataTestId'];
  qaId?: string;
  textWrap?: TextWrapOption;
}

const DropdownWithChildrenToggler: FC<Props> = ({
  withSelectionsResult,
  isDisabled,
  isChildrensContentFilled,
  isClearable,
  id,
  placeholder,
  dropdownTogglerType,
  selectionsResultType,
  toggleLabel,
  onOptionsFetch,
  dataTestId,
  qaId,
  textWrap,
}) => {
  const {
    isDropdownOpen,
    isSomeDropdownOptionsSelected,
    isSelectionsResultExist,
    selectionsResult,
    searchInputValue,
    handleSearchInputValueChange,
    handleSelectedOptionsClear,
    togglerRef,
  } = useDropdownWithChildrenContext();

  const isToggleLabelExist = Boolean(toggleLabel);

  return (
    <>
      {dropdownTogglerType === DropdownTogglerTypeEnum.button && (
        <DropdownWithChildrenTogglerButton
          isToggleLabelExist={isToggleLabelExist}
          isChildrensContentFilled={isChildrensContentFilled}
          isSomeDropdownOptionsSelected={isSomeDropdownOptionsSelected}
          isSelectionsResultExist={isSelectionsResultExist}
          isDisabled={isDisabled}
          isClearable={isClearable}
          withSelectionsResult={withSelectionsResult}
          selectionsResult={selectionsResult}
          id={id}
          toggleLabel={toggleLabel}
          selectionsResultType={selectionsResultType}
          handleSelectedOptionsClear={handleSelectedOptionsClear}
          onOptionsFetch={onOptionsFetch}
          dataTestId={dataTestId}
          qaId={qaId}
          textWrap={textWrap}
        />
      )}
      {dropdownTogglerType === DropdownTogglerTypeEnum.input && (
        <DropdownWithChildrenTogglerInput
          isDropdownTogglerInputFocused={isDropdownOpen}
          isDisabled={isDisabled}
          isClearable={isClearable}
          withSelectionsResult={withSelectionsResult}
          id={id}
          placeholder={placeholder}
          selectionsResult={selectionsResult}
          searchInputValue={searchInputValue}
          selectionsResultType={selectionsResultType}
          handleSearchInputValueChange={handleSearchInputValueChange}
          handleSelectedOptionsClear={handleSelectedOptionsClear}
          togglerRef={togglerRef}
          toggleLabel={toggleLabel}
          dataTestId={dataTestId}
          qaId={qaId}
        />
      )}
    </>
  );
};

export default memo(DropdownWithChildrenToggler);
